export default __webpack_public_path__ + "static/media/home-slider3.dcb3f84b.svg";